var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLusidLogoColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 3240,
    height: 979.2665588508686,
    viewBox: "0 0 3240 979.2665588508686",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(12) translate(10, 10)"
  }, /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1718"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1719",
    featureKey: "k6v3K5-0",
    transform: "matrix(5.590339263202225,0,0,5.590339263202225,-13.416814764821636,-51.990156214053286)",
    fill: "#004182"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.04 20 l-7.64 0 l0 -10.36 l2.14 0 l0 8.28 l5.5 0 l0 2.08 z M15.395 20.32 l-0.04 0 q-2.28 0 -3.56 -1.06 q-1.42 -1.12 -1.42 -3.32 l0 -6.3 l2.06 0 l0 6.3 q0 1.26 0.82 1.8 q0.7 0.5 2.12 0.5 t2.14 -0.5 q0.8 -0.54 0.8 -1.8 l0 -6.3 l2.06 0 l0 6.3 q0 2.2 -1.4 3.32 q-1.3 1.06 -3.58 1.06 z M30.45 10.6 l-1.38 1.6 q-1.1 -0.9 -3.08 -0.9 q-0.78 0 -1.44 0.34 t-0.66 0.78 q0 0.36 0.14 0.54 q0.18 0.26 0.64 0.36 q0.52 0.14 1.48 0.14 q2.08 0 3.28 0.46 q1.06 0.38 1.48 1.14 q0.34 0.62 0.34 1.58 q0 1.8 -1.5 2.76 q-1.42 0.92 -3.74 0.92 q-1.34 0 -2.59 -0.59 t-2.11 -1.61 l1.48 -1.5 l0.18 0.2 q0.42 0.44 0.68 0.68 q0.46 0.38 0.96 0.58 q0.62 0.24 1.4 0.24 q1.44 0 2.32 -0.44 t0.88 -1.24 q0 -0.68 -0.78 -0.92 q-0.7 -0.22 -2.42 -0.22 q-2 0 -3.06 -0.7 q-1.22 -0.76 -1.22 -2.38 q0 -0.92 0.6 -1.64 q0.56 -0.7 1.54 -1.09 t2.14 -0.39 q1.24 0 2.22 0.26 q1.16 0.3 2.22 1.04 z M34.425 20 l-2.04 0 l0 -10.36 l2.04 0 l0 10.36 z M41.88 11.7 l-2.06 0 l0 6.22 l2.06 0 q1.5 0 2.32 -0.82 t0.82 -2.32 t-0.81 -2.29 t-2.33 -0.79 z M36.38 11.7 l-0.92 -2.06 l6.42 0 q1.56 0 2.75 0.59 t1.83 1.73 q0.66 1.16 0.66 2.77 t-0.65 2.8 t-1.84 1.83 t-2.75 0.64 l-4.22 0 l0 -8.3 l-1.28 0 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLusidLogoColor);
export default __webpack_public_path__ + "static/media/lusid-logo-color.553debff2084748a54f106d62ce794d5.svg";
export { ForwardRef as ReactComponent };